/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { DlpPolicyItem, TabsEnum } from 'src/pages/Policy/utils/types';
import { PolicyProvider } from '@Policy/store';
import General from './General';
import DlpFilter from './Dlp';
import ShareLink from './ShareLink';

import { DlpPolicy } from '../../../Components/DlpPolicyEntry';
import KeywordExtraction from './KeywordExtraction';

const DlpBoxPolicy = (props: {
  template: DlpPolicyItem;
  config: any;
  orgId: string;
}) => {
  const { template, config, orgId } = props;
  const { policySubType } = template;
  const tabs = React.useMemo(() => {
    return policySubType === 0
      ? [TabsEnum.general, TabsEnum.dlp, TabsEnum.keywordExtraction]
      : [TabsEnum.general, TabsEnum.shareLink];
  }, [policySubType]);
  const tabPanels = React.useMemo(() => {
    return policySubType === 0
      ? [General, DlpFilter, KeywordExtraction]
      : [General, ShareLink];
  }, [policySubType]);
  console.log(template, config, orgId);
  return (
    <PolicyProvider template={template} config={config} orgId={orgId}>
      <DlpPolicy tabs={tabs} tabPanels={tabPanels} />
    </PolicyProvider>
  );
};
export default React.memo(DlpBoxPolicy);
